import Vue from "vue";
import Vuex from "vuex";
import solution from "@/store/mudules/solution";
import login from "@/store/mudules/login";
import production from "@/store/mudules/production";
import cart from "@/store/mudules/cart";
import header from "@/store/mudules/header";
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    solution,
    login,
    production,
    cart,
    header
  },
  plugins: [
    createPersistedState({
      key: "store",
      paths: ["solution","login","production","cart","header"],
    }),
  ],
});
